<template lang="pug">
    v-layout(wrap align-center :class="name" class="mt-2")
        v-flex(grow)
            e-typography-heading-3 {{$t(`modules.blocks.${name}.title`)}}
        v-flex(shrink)
            e-button-primary-plus(@click="$emit('click:generate-password')")
</template>

<script>
    let name = 'm-block-user-one-time-password-generate';

    export default {
        name: name,
        props: {
            name: {
                type: String,
                default: name
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>




